import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React,{useContext} from "react";
import { makeStyles } from "@material-ui/core";
import download from '../../../image/download.svg';
import time from '../../../image/time.svg';
import question from '../../../image/question.svg';
import paper3 from '../../../image/paper3.svg';
import lock from '../../../image/lock.svg';
import { Link } from "react-router-dom";
import appContext from "../../../../context/AppContext";
import popupContext from "../../../../context/PopupContext/PopupContext";
import { postAttemptPyp,testPYPLogin } from "../../../../service/services";



const useStyles = makeStyles((theme) => ({
  container: {
    "& .MuiTypography-h3": {
      color: "#252525",
      fontSize: "1.2rem",
      fontFamily: "Playfair Display",
      fontWeight: "700",
      textTransform: "capitalize",
      [theme.breakpoints.down("xs")]: {
        textAlign: "center",
        fontSize: "1rem",
      },
    },
  },

  chip: {
    background: '#24C26B',
    color: 'white',
    padding: '0.5rem 0.8rem',
    marginRight: '0.5rem',
    fontSize: '0.8rem',
  },
  chip2: {
    background: '#FFBD64',
    color: 'white',
    padding: '0.5rem 0.8rem',
    marginRight: '0.5rem',
    fontSize: '0.8rem',
  },
  name: {
    fontSize: '1.1rem',
    [theme.breakpoints.down("xs")]: {
      fontSize: '1rem',
    },
  },
  info: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  img: {
    paddingRight: '0.5rem',
    height: '18px',
    opacity:'0.4'
  },
  infoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
    flexDirection: 'row',
    
  },
  bluebutton: {
    background: "linear-gradient(90deg, #FFD9B5 0%, #FFEEC3 100%)",
    width: "40%",
    whiteSpace: "nowrap",
    color:"#243B55",
    '&:hover': {
      background: "linear-gradient(90deg, #FFD669 0%, #FFA046 100%)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
  },
  orangebutton: {
    background: "linear-gradient(90deg, #FFD9B5 0%, #FFEEC3 100%)",
    color: "#20324A",
    width: "100%",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    '&:hover': {
      background: "linear-gradient(90deg, #FFD669 0%, #FFA046 100%)",
    },
  },
}));

const TestCard = ({ test }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    const { isLoggedIn, token } = useContext(appContext);

      const { handleloginOpenclose } = useContext(popupContext);
        const AppContext = useContext(appContext);
      
    
  const handleTestPYPLogin = async (rowId) => {
      try {
        const token = localStorage.getItem("token");
  
        const data = {
          exam: {
            pyp_id: rowId,
          },
        };
  
        const att = postAttemptPyp({
          attempts: {
            user_id: AppContext?.user?.id,
            previous_year_paper_id: rowId,
          },
        });
        // Call testSeriesLogin function
        const response = await testPYPLogin(data, token);
        if (response.status === 200) {
          const responseData = response.data;
          const token = responseData.user.token;
          const userName = responseData.user.full_name;
          localStorage.setItem("userName", userName);
          localStorage.setItem("examToken", token);
          localStorage.setItem("test_series_id", rowId);
  
          const newTab = window.open(
            `${process.env.REACT_APP_API_TESTSERIES_URL}/?token=${token}&userName=${userName}`,
            "_blank"
          );
  
          if (newTab) {
            setTimeout(() => {
              newTab.location.href = `${
                process.env.REACT_APP_API_TESTSERIES_URL
              }/?token=${token}&userName=${userName}&test_series_id=${rowId}&type=${"pyp"}`;
            }, 1000);
          }
  
          // const newTab = window.open(
          //   `http://localhost:3001/?token=${token}&userName=${userName}`,
          //   "_blank"
          // );
  
          // if (newTab) {
          //   setTimeout(() => {
          //     newTab.location.href = `http://localhost:3001/?token=${token}&userName=${userName}&test_series_id=${rowId}`;
          //   }, 1000);
          // }
        }
      } catch (error) {
        // toast.error("Seller is Inactive so cannot login");
        console.error("Error in login: ", error);
      }
    };

  return (
    <Card className={classes.container} sx={{ boxShadow: 3, borderRadius: 2, padding: isMobile ? 1 : 2 }}>
      <CardContent>
        <Box display="flex" gap={0.5} mb={1} justifyContent={"flex-start"}>
          <Chip className={classes.chip} label={test.payment_status} size="small" />
          <Chip className={classes.chip2} label={test.type} size="small" />
          {test.result && (
            <Chip
              className={classes.chip2}
              label={test.result === "with_solution" ? "With Solution" : "Without Solution"}
              size="small"
            />
          )}
        </Box>

        <Typography className={classes.name} variant="h5" gutterBottom>
          {test.previous_year_paper_name}
        </Typography>

        <div className={classes.info}>
          <Box display="flex" alignItems="center">
            <img src={time} className={classes.img} alt="" />
            <Typography variant="body2">Duration: {test.duration}</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <img src={question} className={classes.img} alt="" />
            <Typography variant="body2">No. Of Ques: {test.no_of_question}</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <img src={paper3} className={classes.img} alt="" />
            <Typography variant="body2">Total Marks: {test.totalMarks}</Typography>
          </Box>
        </div>

        <Box mt={2} className={classes.buttonWrapper}>
          <Button
           onClick={() => {
            if (isLoggedIn && token) {
              // window.open(`/previousyearpapers/${test.id}`, "_blank");

              handleTestPYPLogin(test?.id);

            } else {
              handleloginOpenclose();
            }
          }}
            variant="contained"
            disabled={test.payment_status === "paid"}
            className={classes.bluebutton}
            color={"primary"}
          >
            {test.payment_status === "paid" && <img src={lock} className={classes.img} alt="lock" />}
            {test.payment_status === "paid" ? "Unlock Now" : "Start Now"}
          </Button>
          {test.payment_status === "free" && test.type === "pdf" && (
            <Link to={test.pdf_url} target="_blank" rel="noopener noreferrer">
              <Button variant="contained" className={classes.orangebutton}>
                <img src={download} alt="download" />
              </Button>
            </Link>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default TestCard;
